import {
  Injectable,
  Inject,
  autobind,
  forwardRef,
} from '@kaokei/use-vue-service';

import { DaoService } from '../dao.service';

import { ExamService } from './exam.service';

import lifecycle from 'page-lifecycle/dist/lifecycle.es5.js';

import { environment, DEBUG_ENV } from '@/utils';

@Injectable()
export class CheatService {
  @Inject(forwardRef(() => ExamService))
  public examService!: ExamService;

  public maskVisible = false;

  /**
   * 临时禁止防作弊功能
   * 主要是在请求音视频权限的时候临时禁止
   *
   * @memberof CheatService
   */
  public disabled = false;

  constructor(public daoService: DaoService) {}

  public disable() {
    this.disabled = true;
  }

  public enable() {
    this.disabled = false;
  }

  /**
   * 在业务代码中手动初始化事件监听
   *
   * @memberof CheatService
   */
  public initEvent() {
    lifecycle.addEventListener('statechange', this.pageStateChangeHandler);
  }

  @autobind
  public pageStateChangeHandler(event: any) {
    if (!(environment !== 'production' && DEBUG_ENV.cheat)) {
      if (event.newState !== 'active' && !this.maskVisible) {
        if (!this.disabled) {
          this.maskVisible = true;
          this.leave();
        }
      }
    }
  }

  /**
   * 上传防作弊记录
   *
   * @param {number} opType 1代表返回浏览器 2代表离开浏览器
   * @return {*}
   * @memberof CheatService
   */
  public cheatRecord(opType: number) {
    return this.daoService.cheatRecord({
      opType,
      answerPaperId: this.examService.answerPaperId,
      userExamId: this.examService.userExamId,
    });
  }
  /**
   * 返回浏览器
   * 上传防作弊记录
   *
   * @memberof CheatService
   */
  @autobind
  public reback() {
    this.maskVisible = false;
    this.cheatRecord(1);
  }
  /**
   * 离开浏览器
   * 上传防作弊记录
   *
   * @memberof CheatService
   */
  public leave() {
    this.cheatRecord(2);
  }

  public dispose() {
    this.maskVisible = false;
    lifecycle.removeEventListener('statechange', this.pageStateChangeHandler);
  }
}
